const items = [
  "CHINE",
  "USA",
  "EUROPE",
  "INDE",
  "DOLLAR",
  "IA",
  "DATACENTER",
  "DÉFENSE",
  "ÉNERGIE",
  "SEMI-CONDUCTEURS",
  "TERRES RARES",
  "MINERAIS CRITIQUES",
  "ROBOTIQUE",
  "SATELLITES",
  "QUANTIQUE",
  "SOUVERAINETÉ",
  "CAPITAUX",
  "GÉOPOLITIQUE",
];

export default function Marquee() {
  const row = [...items, ...items];
  return (
    <div
      data-testid="editorial-marquee"
      aria-label="Thèmes de la formation"
      className="overflow-hidden border-y border-white/10 bg-[#0A1F1A]/60 py-4"
    >
      <div className="animate-marquee flex w-max whitespace-nowrap">
        {row.map((item, i) => (
          <span key={i} className="font-mono text-sm tracking-[0.2em] text-[#A3B8B0] flex items-center">
            <span className="px-6">{item}</span>
            <span className="text-[#D92D20]">·</span>
          </span>
        ))}
      </div>
    </div>
  );
}
